const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%20with%20warm%20natural%20lighting%2C%20soft%20background%20blur%2C%20friendly%20expression%2C%20casual%20style%2C%20headshot%20photography&width=200&height=200&seq=avatar-cmt-01&orientation=squarish',
    name: '追剧小达人',
    time: '3 天前',
    content: '久久影视真的是我找到的最好的电视剧全集免费平台！《庆余年第二季》全集一次性看完太爽了，高清不卡顿，推荐给所有剧迷朋友！',
    likes: '2.3k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20man%20with%20warm%20natural%20lighting%2C%20soft%20background%20blur%2C%20friendly%20expression%2C%20casual%20style%2C%20headshot%20photography&width=200&height=200&seq=avatar-cmt-02&orientation=squarish',
    name: '韩剧迷阿泽',
    time: '5 天前',
    content: '韩剧全集在线观看终于不用到处找了！《眼泪女王》全集中字版上线的第一时间就在这里看到了，翻译质量很高，播放也很流畅。',
    likes: '1.8k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%20with%20warm%20natural%20lighting%2C%20soft%20background%20blur%2C%20friendly%20expression%2C%20casual%20style%2C%20headshot%20photography&width=200&height=200&seq=avatar-cmt-03&orientation=squarish',
    name: '古装控小乔',
    time: '6 天前',
    content: '作为一个重度古装剧爱好者，久久影视的国产剧全集资源真的太丰富了！《长相思》《与凤行》这些热剧全集都有，幸福感爆棚。',
    likes: '1.5k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20man%20with%20warm%20natural%20lighting%2C%20soft%20background%20blur%2C%20friendly%20expression%2C%20casual%20style%2C%20headshot%20photography&width=200&height=200&seq=avatar-cmt-04&orientation=squarish',
    name: '深夜追剧人',
    time: '1 周前',
    content: '电视剧免费在线观看还能做到高清秒播，真的没谁了。夜间模式对熬夜追剧党太友好了，已经推荐给身边所有同事了！',
    likes: '980',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">剧迷热评</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            看看剧迷们怎么说久久影视，真实用户评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-foreground-900 text-sm">{comment.name}</h3>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
              <div className="mt-3 flex items-center gap-1 text-foreground-500 text-xs">
                <i className="ri-heart-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}